import { useEffect, useState } from "react";
import { fmtError, fmtDateShort } from "@/lib/api";
import { useTenant } from "@/context/TenantContext";
import { Loader2, Search, Mail, Phone } from "lucide-react";

export default function ClientsPage() {
  const { api } = useTenant();
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!api) return;
    api.listClients().then(setItems).catch((e) => setError(fmtError(e)));
  }, [api]);

  if (!items) return <div className="flex items-center justify-center py-20"><Loader2 className="animate-spin text-[#A78BFA]" /></div>;

  const filtered = items.filter((c) =>
    !q.trim() || `${c.name} ${c.email} ${c.phone || ""}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="clients-page">
      <div className="text-[11px] tracking-[0.3em] uppercase text-[#A78BFA] mb-3">Clienti</div>
      <h1 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">
        Le tue <span className="italic">clienti.</span>
      </h1>

      <div className="mt-8 max-w-md relative">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#737373]" />
        <input
          data-testid="clients-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Cerca per nome, email…"
          className="w-full bg-white border border-black/10 rounded-full pl-11 pr-4 py-3 text-sm focus:outline-none focus:border-[#A78BFA]"
        />
      </div>

      {error && <div className="mt-4 text-sm text-[#B91C1C]">{error}</div>}

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="clients-grid">
        {filtered.map((c) => {
          const initials = c.name.split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();
          return (
            <div key={c.id} data-testid={`client-${c.id}`} className="rounded-3xl border border-black/5 bg-white p-6 tilt-card">
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#A78BFA] to-[#67E8F9] text-white flex items-center justify-center font-medium">
                  {initials}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-[#1A1A1A] truncate">{c.name}</div>
                  <div className="text-xs text-[#737373]">Iscritta {fmtDateShort(c.created_at)}</div>
                </div>
              </div>
              <div className="mt-4 space-y-1.5 text-sm text-[#4A4A4A] font-light">
                <div className="inline-flex items-center gap-2"><Mail size={14} className="text-[#A78BFA]" /> <span className="truncate">{c.email}</span></div>
                {c.phone && <div className="inline-flex items-center gap-2"><Phone size={14} className="text-[#A78BFA]" /> {c.phone}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
